export interface DeleteInspectionRequest {
  id: number
  revision: number
}

export function DeleteInspectionToJSON(value: DeleteInspectionRequest): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    revision: value.revision !== 0 ? value.revision : undefined
  }
}
